import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Input, Label, Button, Alert } from 'reactstrap';
import cloneDeep from 'lodash/cloneDeep';
import {
  getFinishConfirmation,
  saveFinishConfirmation,
} from '../../actions/confirmation';
import { isLocal, domain } from '../../config';

const path = isLocal ? '//localhost:3002/#' : `${domain}/company/#`;

const mapStateToProps = ({
  confirmation,
  user: { options },
}) => ({
  confirmation,
  errorMessage: confirmation.message,
  allow_chat: options && options.allow_chat,
  hide_links_on_learning: options && options.hide_links_on_learning,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getFinishConfirmation,
  saveFinishConfirmation,
}, dispatch);

class EndConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.id = +props.match.params.id;

    this.state = {
      end_confirmed: false,
      errorMessage: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.props.getFinishConfirmation(this.id);
  }

  handleChange({ target }) {
    this.setState({
      [target.id]: (target.type === 'checkbox') ? target.checked : target.value,
      errorMessage: '',
    });
  }

  submit() {
    const { end_confirmed } = this.state;
    if (end_confirmed) {
      this.props.saveFinishConfirmation(this.id);
    }
  }

  render() {
    if (!this.props.confirmation.cycle_id && !this.props.errorMessage) {
      return null;
    }
    const { confirmation, allow_chat, hide_links_on_learning } = this.props;
    const { end_confirmed } = this.state;
    this.state = { ...cloneDeep(confirmation), end_confirmed };
    const { errorMessage } = this.state;
    const { cycle_id, started, finished, end_text, training_status } = confirmation;
    if (finished || this.props.errorMessage) {
      return <Redirect to={`/trainings/mytrainings/${this.id}/lessons`} />;
    }

    return (
      <React.Fragment>
        {!hide_links_on_learning &&
        <div className="category_block">
          <ul>
            {allow_chat && (
              <li className="category">
                <Link to="/trainings/chats">
                  <i className="icon_c icon_c_bg icon_chats" />
                  <FormattedMessage id="routes_chats" />
                </Link>
              </li>
            )}
            <li className="category">
              <a href={`${path}/reports/users`}>
                <i className="icon_c icon_c_bg icon_reports" />
                <FormattedMessage id="routes_reports" />
              </a>
            </li>
            <li className="category">
              <Link to="/trainings/notes">
                <i className="icon_c icon_c_bg icon_notes" />
                <FormattedMessage id="routes_notes" />
              </Link>
            </li>
            <li className="category">
              <Link to="/trainings/pictures">
                <i className="icon_c icon_c_bg icon_images" />
                <FormattedMessage id="routes_pictures" />
              </Link>
            </li>
            <li className="category">
              <Link to="/trainings/certificates">
                <i className="icon_c icon_c_bg icon_cert" />
                <FormattedMessage id="routes_certificates" />
              </Link>
            </li>
          </ul>
        </div>
        }
        <div className="main_content">
          <section>
            <header>
              <div className="question">
                <p className="title"><FormattedMessage id="mytrainings_end_title" /></p>
              </div>
            </header>
            <div className="content">
              <div className="col-lg-12 tc" dangerouslySetInnerHTML={{ __html: end_text }} />
              <div className="clear20" />
              <div className="col-lg-12 tc">
                <Input
                  id="end_confirmed"
                  name="end_confirmed"
                  type="checkbox"
                  onChange={this.handleChange}
                  checked={this.state.end_confirmed}
                />
                <Label htmlFor="end_confirmed"><FormattedMessage id="mytrainings_start_iRead" /></Label>
              </div>
              <div className="clear20" />
              <div className="col-lg-12 tc"><FormattedMessage id="mytrainings_end_clickToReceive" /></div>
              <div className="clear20" />
              {errorMessage && <Alert color="danger"><FormattedMessage id={errorMessage} /></Alert>}
              <div className="col-lg-12 tc">
                <Button
                  className="btn btn-custom btn-lg next_btn f20"
                  onClick={this.submit}
                ><FormattedMessage id="overall_input_continue" /></Button>
              </div>
              <div className="clear10" />
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

EndConfirmation.propTypes = {
  confirmation: PropTypes.objectOf(PropTypes.any),
  match: PropTypes.objectOf(PropTypes.any),
  allow_chat: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(EndConfirmation);



// WEBPACK FOOTER //
// ./src/views/_MyTrainings/end.js